import { register } from '../../utils/index.mjs';
import './default/index.vue.mjs';
import './follow/index.vue.mjs';
import './function/index.vue.mjs';
export { UiTooltipFollowEmits, UiTooltipFollowPropsOption } from './follow/index.mjs';
export { UiTooltipEmits, UiTooltipPropsOption } from './default/index.mjs';
export { UiTooltipFunctionEmits, UiTooltipFunctionPropsOption } from './function/index.mjs';
import _sfc_main from './default/index.vue2.mjs';
import _sfc_main$1 from './follow/index.vue2.mjs';
import _sfc_main$2 from './function/index.vue2.mjs';

const UiTooltip = register.use(_sfc_main, "component");
const UiTooltipFollow = register.use(_sfc_main$1, "component");
const UiTooltipFunction = register.use(_sfc_main$2, "component");

export { UiTooltip, UiTooltipFollow, UiTooltipFunction, UiTooltip as default };
//# sourceMappingURL=index.mjs.map
